<template>
    <div class="filter-pill" data-filter-value="value">
        <span class="filter-pill__text">{{ label }}</span>
        <button class="filter-pill__remove" @click="removeFilter" :aria-label="`Remove ${label} filter`">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
        </button>
        <div class="filter-pill__separator"></div>
    </div>
</template>

<script>
export default {
    name: 'FilterPill',
    props: {
        value: {
            type: [String, Number],
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    methods: {
        removeFilter() {
            this.$emit('remove', {
                value: this.value,
                label: this.label,
                type: this.type
            });
        }
    }
};
</script>

<style scoped>
.filter-pill {
    position: relative;
    display: inline-flex;
    align-items: center;
    background-color: rgba(102, 102, 102, 0.3);
    height: 40px;
    padding: 0 12px 0 16px;
    margin-right: 8px;
    margin-bottom: 8px;
}

.filter-pill__text {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: #1e1e1e;
    margin-right: 12px;
    white-space: nowrap;
}

.filter-pill__remove {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    transition: color 0.2s ease;
}

.filter-pill__remove:hover {
    color: #000;
}

.filter-pill__remove:focus {
    outline: none;
    color: #000;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 2px;
}

.filter-pill__separator {
    position: absolute;
    right: -4px;
    top: 50%;
    transform: translateY(-50%) rotate(90deg);
    width: 40px;
    height: 1px;
    background: linear-gradient(to right, #ccc 0%, transparent 100%);
}

.filter-pill:last-child .filter-pill__separator {
    display: none;
}
</style>